import { Action } from '@ngrx/store';

export interface Job {
  id: number;
  UserId: number;
  FollowId: number;
  type: string;
  metadata: Partial<JobMetadata>;
  createdAt: Date;
  updatedAt: Date;
}

export interface JobMetadata {
  status: string;
  totalProducts: number;
  totalImgs: number;
  urls: any[];
}

export enum JobActionTypes {
  GetJobsInfo = '[Job] Get jobs info',
  GetJobsInfoSuccess = '[Job] Get jobs info success',
  GetJobsInfoFail = '[Job] Get jobs info fail'
}

export class GetJobsInfo implements Action {
  readonly type = JobActionTypes.GetJobsInfo;
  constructor(public data?: any) {}
}

export class GetJobsInfoSuccess implements Action {
  readonly type = JobActionTypes.GetJobsInfoSuccess;
  constructor(public jobs: any) {}
}

export class GetJobsInfoFail implements Action {
  readonly type = JobActionTypes.GetJobsInfoFail;
  constructor(public error: any) {}
}


export type JobActionsUnion =
  | GetJobsInfo
  | GetJobsInfoSuccess
  | GetJobsInfoFail;
